module.exports = __webpack_public_path__ + "img/laboratorio_4-3.dd5db0ee.webp";